import { API } from "shared/constants/AppEnums"

export const addSurvey = async (payload) => {
    try {
        const response = await fetch(API.ADD_SURVEY, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getSurveyReport = async (page, year) => {
    try {
        const url = page === 1 ? API.GET_SURVEY_REPORT.replace('page=$page', '') + `year=${year}` : API.GET_SURVEY_REPORT.replace('$page', page) + `&year=${year}`
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getSurveyCount = async (year) => {
    try {
        const response = await fetch(API.GET_SURVEY_COUNT + `?year=${year}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getSurveyDetail = async (id) => {
    try {
        const response = await fetch(API.GET_SURVEY_DETAIL.replace('$id', id), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getSurveyExport = async (year) => {
    try {
        const response = await fetch(API.GET_SURVEY_EXPORT.replace('$year', year), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}